import login from './login/login_en'
import forgotPassword from './forgotPassword/forgotPassword_en'
import changePassword from './changePassword/changePassword_en'
import updatePassword from './updatePassword/updatePassword_en'
import home from './home/home_en'
import ripsDetail from './rips/ripsDetail_en'
import errorsAndNotifications_en from './errorsAndNotifications/errorsAndNotifications_en'
import dashboard from './dashboard/dashboard_en'

export default {
  globalErrorUnknown: 'We had a technical glitch! Please, try again or contact your technical support team.',
  loading: 'Loading',
  errorTitle: 'An error has occurred',
  defaultErrorDescription: 'Please contact the support team for more information.',
  badCredentials: '¡Bad credentials! Please, try again.',
  buttons: {
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    accept: 'Accept',
    add: 'Add',
    search: 'Search',
  },
  errors: {
    inputValidations: {
      required: 'Required field',
      invalidFormat: 'Invalid format',
      maxLength: 'The field has exceed the {n} characters limit',
      minLength: '{n} characters minimum'
    },
    authorizationRequest: {
      emptyAuthorization: "Authorization creation failed, please contact the support team for more information."
    },
    dispensingRequest: {
      emptyApprovedProducts: "No product was approved for this authorization, please contact the support team for more information."
    },
    voidAuthorizations: {
      success: 'Authorization successfully voided.'
    }
  },
  drawer: {
    logout: 'Logout'
  },
  footer: {
    privacyLabel: 'Privacy'
  },
  locales: {
    'es-DO': 'Spanish',
    es: 'Spanish',
    en: 'English'
  },
  identityDocumentTypes: {
      passport: 'Passport',
      nationalIdentityCard: 'National identity card',
      socialSecurityNumber: 'Social security number',
      taxIdentificationNumber: 'Tax identification number',
      electoralRegistryNumber: 'Electoral registry number'
  },
  genders: {
    male: 'Male',
    female: 'Female'
  },
  posology: {
      day: '{value} day | {value} days',
      unit: 'unit | units',
      medicalDeviceDescription: 'Use {0} ({1}) {2} for {3} ({4}) {5}',
      half: 'half',
      andConnector: 'and a',
      pointConnector: 'point',
      quarter: 'one quarter | {value} quarter',
  },
  sponsors: {
    umbrella: "Umbrella Osigu ARS",
    humano: 'Humano Seguros',
    universal: 'ARS Universal',
    primera: 'ARS Primera',
    humanoCategories: {
      global: "Global",
      platinum: "Platinum",
      conventional: "Convensional"
    }
  },
  voidAuthorization: {
    back: "Back",
    confirm: "Yes, cancel",
    title: "Cancel authorization",
    titleOnlyClaim: "Cancel claim",
    hint: "Confirm to cancel this authorization. This action cannot be reverted.",
    hintOnlyClaim: "Confirm to cancel this claim. This action cannot be reverted."
  },
  actions: {
    upload: 'Upload',
    delete: 'Delete',
    replace: 'Replace',
    view: 'Visualize',
    download: 'Download',
    edit: 'Edit'
  },
  yes: 'Yes',
  no: 'No',
  supportFileUploadSuccess: 'File uploaded successfully',
  SupportFileDeleteSeccess: 'File deleted successfully',
  supportFileRestrictedAsAccountLevel: 'Required at account level',
  emptyResults: "No results found",
  cancelFormButton: "Cancel",
  chronicTreatmentLabel: 'Chronic treatment',
  errorLoadingFile: 'An error occurred while loading the file, please try again or contact your technical support team.',
  informationSuccessfullyUpdated: 'Information successfully updated',
  invalidFileType: 'Invalid file type, valid types are: {types}',
  login,
  forgotPassword,
  changePassword,
  updatePassword,
  home,
  ripsDetail,
  errorsAndNotifications_en,
  dashboard
}
